
  import CaseDetails from '@/components/case/CaseDetails.vue';
  import Layout from '@/components/Layout.vue';
  import { Options, Vue } from 'vue-class-component';

  @Options({
    components: {
      Layout,
      CaseDetails,
    },
  })
  export default class CaseView extends Vue {}
